import React, { ReactNode, useCallback } from 'react'
import { Section, SectionList } from '../../common/SectionList'
import { BoardListItem } from './BoardListItem'
import { BoardRole } from '../../../types/board-roles'
import { translateRole } from '../../../helpers/society'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { sortBoardMembersList } from './sortBoardMembersList'
import { ESocietyBoardRole } from '../../../interfaces/models/societies.interfaces'

export const BoardList = (): ReactNode => {
  const { society } = useCurrentSociety()

  const getSections = useCallback((): Section[] => {
    return [
      {
        title: '',
        item: (
          <div>
            {sortBoardMembersList(society).map((member) => {
              return <BoardListItem key={member.userId} boardMember={member} />
            })}
          </div>
        ),
      },
      ...(society?.nominatingCommitteeList &&
      society.nominatingCommitteeList.length > 0
        ? [
            {
              title: translateRole(BoardRole.NOMINATING_COMMITTEE) || '',
              item: (
                <div>
                  {society.nominatingCommitteeList?.map((member) => {
                    const boardMember = {
                      userId: member.userId,
                      role: ESocietyBoardRole.NominatingCommittee,
                    }
                    return (
                      <BoardListItem
                        key={boardMember.userId}
                        boardMember={boardMember}
                      />
                    )
                  })}
                </div>
              ),
            },
          ]
        : []),
    ]
  }, [society])

  return <SectionList sections={getSections()} />
}
